export default "__VITE_ASSET__BB098r4O__"